type Props = {
  heading: string;
  text: string;
};

const TerminatedBlock = ({ heading, text }: Props) => {
  return (
    <div className="p-6 rounded-lg bg-white border border-border text-[11px] space-y-2 text-center leading-[1.8]">
      <div className="text-foreground font-semibold">{heading}</div>
      <p className="text-muted-foreground">{text}</p>
    </div>
  );
};

export default TerminatedBlock;
